<template>
	<div>
		<p>
			<b>{{ companyName }} ist an einem Ersatztermin interessiert. Bitte teile uns mit ob du auch noch
			interessiert bist</b>
		</p>
		<RadioGroup
			v-model="followUp"
			:options="followUpOptions"
			stacked
		/>
		<JonInfo v-if="followUpInterested" class="mt-3">
			<template #message>
				<b>{{ companyName }}</b> wird informiert dass du an einem Ersatztermin interessiert bist.
				Wir informieren dich sobald <b>{{ companyName }}</b> neue Terminvorschläge für dich hat.
			</template>
		</JonInfo>
		<ApplicantSendOff
			v-if="followUpSendOff"
			v-model="sendOffData"
			:customer="message.customer"
			:is-anonymous="false"
			:with-company-name="false"
			class="mt-3"
		/>
		<div class="mt-3 text-right">
			<Button
				text="Senden"
				icon="checkmark"
				:disabled="!dataValid || sendingRequest"
				:loading="sendingRequest"
				@click="submit"
			/>
		</div>
	</div>
</template>

<script>
import {isDefined} from "@/helper/Value";
import FormGroup from "@/vue/common/form/Group"
import RadioGroup from "@/vue/common/form/RadioGroup";
import Button from "@/vue/common/Button";
import InfoBox from "@/vue/common/InfoBox";
import ApplicantSendOff from "@/vue/communication/conversation/ApplicantSendOff";
import Reply, {
	ACTION_APPLICANT_WANTS_ALTERNATIVE_APPOINTMENT,
	ACTION_SENDOFF
} from "@/api/communication/conversation/message/Reply";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import JonInfo from "@/vue/common/JonInfo.vue";

const FOLLOW_UP_INTERESTED = 'interested';
const FOLLOW_UP_SENDOFF = 'sendoff';

export default {

	components: {
		JonInfo,
		ApplicantSendOff,
		FormGroup,
		RadioGroup,
		InfoBox,
		Button,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			followUp: undefined,
			sendOffData: undefined,
			sendingRequest: false,
		};
	},

	computed: {
		companyName ()
		{
			return this.message.customer.companyName;
		},
		followUpOptions ()
		{
			return [
				{value: FOLLOW_UP_INTERESTED, text: 'Ich bin an einem Ersatztermin interessiert'},
				{value: FOLLOW_UP_SENDOFF, text: 'Von ' + this.companyName + ' verabschieden'},
			];
		},
		followUpInterested ()
		{
			return this.followUp === FOLLOW_UP_INTERESTED;
		},
		followUpSendOff ()
		{
			return this.followUp === FOLLOW_UP_SENDOFF;
		},
		followUpValid ()
		{
			return isDefined(this.followUp);
		},
		sendOffValid ()
		{
			return !this.followUpSendOff || isDefined(this.sendOffData);
		},
		dataValid ()
		{
			return this.followUpValid
				&& this.sendOffValid;
		}
	},

	methods: {
		async submit ()
		{
			this.sendingRequest = true;

			try
			{
				let action = undefined;

				if (this.followUpSendOff)
				{
					action = ACTION_SENDOFF;
				}
				else if (this.followUpInterested)
				{
					action = ACTION_APPLICANT_WANTS_ALTERNATIVE_APPOINTMENT;
				}

				const reply = new Reply()
					.setMessageId(this.message.id)
					.setAction(action);

				if (this.followUpSendOff)
				{
					reply.setCustomerUninterestingType(this.sendOffData.customerUninterestingType);
				}

				await reply.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>
